/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Role } from './Role'
import { RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from './Role'

/**
 * Данные пользователя (App\Http\Resources\UserResource)
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   * @type {string}
   * @memberof User
   */
  uuid: string | null
  /**
   *
   * @type {string}
   * @memberof User
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof User
   */
  lastname?: string | null
  /**
   *
   * @type {string}
   * @memberof User
   */
  patronymic?: string | null
  /**
   *
   * @type {string}
   * @memberof User
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof User
   */
  phone?: string | null
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  active: boolean
  /**
   * Email подтверждён
   * @type {boolean}
   * @memberof User
   */
  emailVerified: boolean
  /**
   * Дата принятия соглашения
   * @type {string}
   * @memberof User
   */
  agreementAccepted?: string | null
  /**
   * Инструкция сервиса пройдена
   * @type {boolean}
   * @memberof User
   */
  instructionPassed: boolean
  /**
   * Роли пользователя (Spatie Permission)
   * @type {Array<Role>}
   * @memberof User
   */
  roles: Array<Role>
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('email' in value) || value['email'] === undefined) return false
  if (!('active' in value) || value['active'] === undefined) return false
  if (!('emailVerified' in value) || value['emailVerified'] === undefined)
    return false
  if (
    !('instructionPassed' in value) ||
    value['instructionPassed'] === undefined
  )
    return false
  if (!('roles' in value) || value['roles'] === undefined) return false
  return true
}

export function UserFromJSON(json: any): User {
  return UserFromJSONTyped(json, false)
}

export function UserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): User {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    lastname: json['lastname'] == null ? undefined : json['lastname'],
    patronymic: json['patronymic'] == null ? undefined : json['patronymic'],
    email: json['email'],
    phone: json['phone'] == null ? undefined : json['phone'],
    active: json['active'],
    emailVerified: json['emailVerified'],
    agreementAccepted:
      json['agreementAccepted'] == null ? undefined : json['agreementAccepted'],
    instructionPassed: json['instructionPassed'],
    roles: (json['roles'] as Array<any>).map(RoleFromJSON),
  }
}

export function UserToJSON(value?: User | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    lastname: value['lastname'],
    patronymic: value['patronymic'],
    email: value['email'],
    phone: value['phone'],
    active: value['active'],
    emailVerified: value['emailVerified'],
    agreementAccepted: value['agreementAccepted'],
    instructionPassed: value['instructionPassed'],
    roles: (value['roles'] as Array<any>).map(RoleToJSON),
  }
}
